import Moment from 'moment-timezone';
import { BasicModel } from '@/models/BasicModel';

/**
 * FileDetail object
 */
export class FileDetail extends BasicModel {
  // FileDetail-specific properties
  id = 0;

  companyId = 0;

  teamId = 0;

  created = '';

  hash = '';

  localPath = '';

  name = '';

  pathname = '';

  refs = [];

  size = 0;

  type = '';

  status = '';

  blob = null;

  constructor(props, autoFill = true) {
    super(props);
    this.setProps(props);
    if (autoFill) {
      this.created = this.created === null ? Moment().format('YYYY-MM-DD HH:mm:ss') : this.created;
    }
  }

  setProps(props) {
    BasicModel.updateObjectProps(props, this);
  }
}

export default {
  FileDetail,
};
